function reducer(state = [], action) {
    switch (action.type) {
        case 'TEAMS/ARCHIVED/SET':            
            return action.archived_teams;
        default:
            return state;
    }
}

export default reducer;
